import React, { useEffect, useState } from 'react';

interface CountdownProps {
    value?: string;
}

const Countdown: React.FC<CountdownProps> = ({ value }) => {
    const [timeLeft, setTimeLeft] = useState<number>(0);

    const targetTime = new Date(value ?? 0).getTime();

    const adjustedTargetTime = new Date(targetTime + 3 * 60 * 60 * 1000 + 30 * 60 * 1000).getTime();

    useEffect(() => {
        const interval = setInterval(() => {
            const currentTime = new Date().getTime();
            const difference = adjustedTargetTime - currentTime;

            if (difference <= 0) {
                clearInterval(interval);
                setTimeLeft(0);
            } else {
                setTimeLeft(difference);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [adjustedTargetTime]);

    const getTimeParts = (timeInMillis: number) => {
        const totalSeconds = Math.floor(timeInMillis / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');

        return { hours, minutes, seconds };
    };

    const { hours, minutes, seconds } = getTimeParts(timeLeft);

    return (
        <div className="flex items-center gap-2" dir="ltr">
            <div className="w-8 h-8 flex items-center justify-center bg-white border border-primary-20 rounded-[4px]">
                {hours}
            </div>
            <span className="text-base">:</span>
            <div className="w-8 h-8 flex items-center justify-center bg-white border border-primary-20 rounded-[4px]">
                {minutes}
            </div>
            <span className="text-base">:</span>
            <div className="w-8 h-8 flex items-center justify-center bg-white border border-primary-20 rounded-[4px]">
                {seconds}
            </div>
        </div>
    );
};

export default Countdown;
